import { gql } from '@apollo/client';

export const LIST_USERS = gql`
  query ListUsers($filters: FilterOptions!) {
    listUsers(filters: $filters) {
      entries {
        id
        username
        name
        email
        organization
        site
        disabled
        locked
        lastlogin
        lastpasswordchange
        permissions {
          permission
          enabled
        }
        lastWarnDate
        warnCount
        twofactorEnabled
        twoFactorStatus
        compliant
        complianceIssues
        handlerUsername
        handlerName
        handlerEmail
        isManager
        passwordfailures
        firstlogin
        createdDate
        deactivationDate
        deactivationReason
      }
      totalCount
    }
  }
`;

export const GET_USER_DETAILS = gql`
  query GetUserDetails($usernames: [String]!) {
    getUserInformation(usernames: $usernames) {
      entries {
        username
        name
        email
        organization
        site
        disabled
        locked
        lastlogin
        lastpasswordchange
        permissions {
          permission
          enabled
        }
        lastWarnDate
        warnCount
        twofactorEnabled
        twoFactorStatus
        compliant
        complianceIssues
        handlerUsername
        handlerName
        handlerEmail
        isManager
        twofactorCode
        passwordfailures
        firstlogin
      }
    }
  }
`;
export const RESET_PASSWORD = gql`
  mutation ResetPassword($username: String!) {
    resetPassword(username: $username) {
      message
    }
  }
`;

export const ENABLE_ACCOUNT = gql`
  mutation EnableAccount($username: String!) {
    enableAccount(username: $username) {      
      message
    }
  }
`;

export const MODIFY_USER = gql`
  mutation ModifyUser(
    $username: String!
	$newUsername: String
    $disabled: Boolean
    $email: String
    $realname: String
    $organization: String
    $site: String
    $password: String
    $permissions: [UserPermissionInput]
    $twoFactorMethod: String
    $passwordfailures: Int
    $handlerUsername: String
    $isManager: Boolean
    $deactivationDate: String
    $deactivationReason: String
  ) {
    modifyUser(
      username: $username
	  newUsername: $newUsername
      disabled: $disabled
      email: $email
      realname: $realname
      organization: $organization
      site: $site
      password: $password
      permissions: $permissions
      twoFactorMethod: $twoFactorMethod
      passwordfailures: $passwordfailures
      handlerUsername: $handlerUsername
      isManager: $isManager
      deactivationDate: $deactivationDate
      deactivationReason: $deactivationReason
    ) {
      message
    }
  }
`; 

export const LIST_MANAGERS = gql`
  query ListManagers {
    listManagers {
      id
      username
      name
      email
      disabled
    }
  }
`;

export const CREATE_USER_ACCOUNT = gql`
  mutation CreateUserAccount($input: CreateUserAccountInput!) {
    createUserAccount(input: $input) {
      success
      message
      createdUserId
      username
      temporaryPassword
    }
  }
`;

export const LIST_CREATE_USER_ACCOUNT_OPTIONS = gql`
  query CreateUserAccountOptions {
    roleOptions: userAccountRequestOptions(optionType: "role") {
      id
      optionType
      label
      sortOrder
      isActive
    }
	    organizationOptions: userAccountRequestOptions(optionType: "organization") {
	      id
	      optionType
	      label
	      sortOrder
	      isActive
	      defaultPrograms
	    }
    siteOptions: userAccountRequestOptions(optionType: "site") {
      id
      optionType
      label
      sortOrder
      isActive
    }
  }
`;

export const LIST_POLICY_ALIASES = gql`
  query ListPolicyAliases {
    listPolicyAliases {
      id
      alias
      type
      description
      active
      policies
    }
  }
`;

export const LIST_POLICY_PRIMITIVES = gql`
  query ListPolicyPrimitives {
    listPolicyPrimitives
  }
`;

export const LIST_POLICY_PRIMITIVES_DETAILED = gql`
  query ListPolicyPrimitivesDetailed {
    listPolicyPrimitivesDetailed {
      policy
      resourcePath
      verb
    }
  }
`;

export const GET_USER_MANAGER_PERMISSION_TEMPLATE_CONFIG = gql`
  query GetUserManagerPermissionTemplateConfig {
    getUserManagerPermissionTemplateConfig {
      templates {
        id
        label
        permissions
      }
    }
  }
`;

export const SAVE_USER_MANAGER_PERMISSION_TEMPLATE_CONFIG = gql`
  mutation SaveUserManagerPermissionTemplateConfig($config: UserManagerPermissionTemplateConfigInput) {
    saveUserManagerPermissionTemplateConfig(config: $config) {
      success
      message
    }
  }
`;

export const LIST_USER_SECURITY_POLICIES = gql`
  query ListUserSecurityPolicies($username: String) {
    listUserSecurityPolicies(username: $username) {
      policy
      allow
    }
  }
`;

export const LIST_GROUP_MEMBERS = gql`
  query ListGroupMembers($alias: String!) {
    listGroupMembers(alias: $alias) {
      id
      username
      name
      email
      disabled
    }
  }
`;

export const UPDATE_USER_SECURITY_POLICIES = gql`
  mutation UpdateUserSecurityPolicies(
    $username: String!
    $policies: [UserSecurityPolicyInput]
  ) {
    updateUserSecurityPolicies(username: $username, policies: $policies) {
      success
      message
    }
  }
`;

export const SAVE_POLICY_ALIAS = gql`
  mutation SavePolicyAlias($alias: PolicyAliasInput) {
    savePolicyAlias(alias: $alias) {
      success
      message
      aliasId
    }
  }
`;

export const DELETE_POLICY_ALIAS = gql`
  mutation DeletePolicyAlias($aliasId: Int) {
    deletePolicyAlias(aliasId: $aliasId) {
      success
      message
    }
  }
`;

export const LOGIN_ALIAS = gql`
  mutation LoginAlias($userid: Int!) {
    loginAlias(userid: $userid) {
      token
      user {
        username
        realname
        groups
        access
        permissions
        id
        loginType
        settings {
          colorTheme
          dashboard
          adminSettingsFavorites
          systemSettingsFavorites
          summaryFilters
          patientBannerExpanded
          ecmDashboardColumnPreferences {
            page
            visibleColumns
          }
          recentParticipants {
            participantId
            odrNumber
            name
            visitedAt
          }
        }
        compliance {
          id
          name
          item
          pdf
          frequencyDays
          lastCompletionDate
          nextDueDate
          dueInDays
          status
          required
          source
        }
      }
    }
  }
`;
